<template>
  <el-dialog
    :visible.sync="show"
    :top="selectCard === '' ? '20vh' : '9vh'"
    width="750px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="main-container">
      <div class="top-container">
        <div class="top-tip">
          {{ languages.reminder }}<span>{{ software.name }}</span>
        </div>
        <div class="dialog-close" @click="closeDialog">X</div>
      </div>
      <div class="middle-container">
        <div class="depart-container">
          {{ languages.depart }}
          <span>{{ lan === 'cn' ? user.department : user.departmentename }}</span>
          <span>{{ lan === 'cn' ? user.jobFamilyCName : user.jobFamilyName }}</span>
        </div>
        <div class="select-container">
          <div class="blank-container" :hidden="cardCount > 1"></div>
          <div class="blank-container" :hidden="cardCount > 2"></div>
          <!-- =============================================== -->
          <div
            class="card-container"
            v-if="showQuickCard"
            @click="chooseCard(1)"
            @mouseover="cardMouseOver(1)"
            @mouseleave="cardMouseLeave(1)"
            :style="[
              { boxShadow: checkHoverShadow(1), border: getBkBorder(1) },
              { backgroundImage: 'url(' + require('@/assets/pics/licence/card1.png') },
            ]"
          >
            <img
              class="card-limit"
              v-if="dayTimeLimit"
              :src="require(`assets/pics/licence/limit1${lan}.png`)"
              alt=""
            />
            <!-- <img class="card-limit"
                 v-if="dayLimit && !dayTimeLimit"
                 :src="require(`assets/pics/licence/limit2${lan}.png`)"
                 alt="" /> -->
            <div class="card-header">{{ languages.flexible }}</div>
            <div class="card-body">
              <div class="card-select">
                <select
                  class="day-select"
                  onClick="event.cancelBubble = true"
                  :onChange="costCalc(software.cost)"
                  v-model="daySelect"
                >
                  <option :value="day" v-for="day in 30" :key="day">{{ day }}</option>
                </select>
                <div class="card-title">{{ languages.cDays }}</div>
              </div>
              <div
                class="limit-container"
                v-if="dayLimit && !dayTimeLimit"
                :style="{
                  backgroundImage: 'url(' + require('@/assets/pics/licence/limit.png') + ')',
                }"
              >
                <div class="limit-text">{{ languages.flexLimit }}</div>
                <div class="limit-text2" v-if="dayReleaseTime">
                  {{ languages.release }} {{ dayReleaseTime }}
                </div>
              </div>
              <div v-if="!dayLimit || dayTimeLimit">
                <div class="card-content">
                  {{ languages.period }}
                  <span>1-30{{ languages.day }}</span>
                </div>
                <div class="card-content">
                  {{ software.cost ? languages.estimate : languages.depCost }}
                  <span>
                    {{ software.cost ? dayCost : languages.vlow }}
                  </span>
                </div>
                <div class="card-content">
                  {{ languages.useFor }}
                  <span>{{ languages.tempUse }}</span>
                </div>
                <div class="card-content" v-if="!isVpUser && !isCostUser">
                  {{ languages.effect }}
                  <span>{{ languages.afterApprove }}</span>
                </div>
              </div>
              <div
                class="radio-container"
                v-bind:class="selectCard === 1 ? 'radio-select' : 'radio-unselect'"
              >
                <div class="radio-dot" v-if="selectCard === 1"></div>
              </div>
              <img src="~/assets/pics/licence/tag1.png" alt="" />
            </div>
            <div class="triangle-up" v-if="selectCard === 1"></div>
          </div>
          <!-- =============================================== -->
          <div
            class="card-container"
            v-if="showShortCard"
            @click="chooseCard(2)"
            @mouseover="cardMouseOver(2)"
            @mouseleave="cardMouseLeave(2)"
            :style="[
              { boxShadow: checkHoverShadow(2), border: getBkBorder(2) },
              { backgroundImage: 'url(' + require('@/assets/pics/licence/card2.png') },
            ]"
          >
            <img
              class="card-limit"
              v-if="monthTimeLimit"
              :src="require(`assets/pics/licence/limit1${lan}.png`)"
              alt=""
            />
            <!-- <img class="card-limit"
                 v-if="monthLimit && !monthTimeLimit"
                 :src="require(`assets/pics/licence/limit2${lan}.png`)"
                 alt="" /> -->
            <div class="card-header">{{ languages.short }}</div>
            <div class="card-body">
              <div class="card-select">
                <select
                  class="day-select"
                  onClick="event.cancelBubble = true"
                  :onChange="costCalc(software.cost)"
                  v-model="monthSelect"
                >
                  <option :value="month" v-for="month in monthSelectLimit ? 1 : 7" :key="month">
                    {{ (month + 2) * 10 }}
                  </option>
                </select>
                <div class="card-title">{{ languages.cDays }}</div>
              </div>
              <div
                class="limit-container"
                v-if="monthLimit && !monthTimeLimit"
                :style="{
                  backgroundImage: 'url(' + require('@/assets/pics/licence/limit.png') + ')',
                }"
              >
                <div class="limit-text">{{ languages.shortLimit }}</div>
                <div class="limit-text2" v-if="monthReleaseTime">
                  {{ languages.release }} {{ monthReleaseTime }}
                </div>
              </div>
              <div v-if="!monthLimit || monthTimeLimit">
                <div class="card-content">
                  {{ languages.period }}
                  <span v-if="!monthSelectLimit">30-90{{ languages.day }}</span>
                  <span v-if="monthSelectLimit">30{{ languages.day }}</span>
                </div>
                <div class="card-content">
                  {{ software.cost ? languages.estimate : languages.depCost }}
                  <span>
                    {{ software.cost ? monthCost : languages.low }}
                  </span>
                </div>
                <div class="card-content">
                  {{ languages.useFor }}
                  <span>{{ languages.shortUse }}</span>
                </div>
                <div class="card-content" v-if="!isVpUser && !isCostUser">
                  {{ languages.effect }}
                  <span>{{ languages.afterApprove }}</span>
                </div>
              </div>
              <div
                class="radio-container"
                v-bind:class="selectCard === 2 ? 'radio-select' : 'radio-unselect'"
              >
                <div class="radio-dot" v-if="selectCard === 2"></div>
              </div>
              <img src="~/assets/pics/licence/tag2.png" alt="" />
            </div>
            <div class="triangle-up" v-if="selectCard === 2"></div>
          </div>
          <!-- =============================================== -->
          <div
            class="card-container"
            :hidden="!showLong || !showLongCard"
            @click="chooseCard(3)"
            @mouseover="cardMouseOver(3)"
            @mouseleave="cardMouseLeave(3)"
            :style="[
              { boxShadow: checkHoverShadow(3), border: getBkBorder(3) },
              { backgroundImage: 'url(' + require('@/assets/pics/licence/card3.png') },
            ]"
          >
            <img
              class="card-limit"
              v-if="yearTimeLimit"
              :src="require(`assets/pics/licence/limit1${lan}.png`)"
              alt=""
            />
            <!-- <img class="card-limit"
                 v-if="yearLimit && !yearTimeLimit"
                 :src="require(`assets/pics/licence/limit2${lan}.png`)"
                 alt="" /> -->
            <div class="card-header">{{ languages.long }}</div>
            <div class="card-body">
              <div class="card-select">
                <div style="line-height: 37px">{{ languages.oneYear }}</div>
              </div>
              <div
                class="limit-container"
                v-if="yearLimit && !yearTimeLimit"
                :style="{
                  backgroundImage: 'url(' + require('@/assets/pics/licence/limit.png') + ')',
                }"
              >
                <div class="limit-text">{{ languages.longLimit }}</div>
                <div class="limit-text2" v-if="yearReleaseTime && !software.noneApply">
                  {{ languages.release }} {{ yearReleaseTime }}
                </div>
                <div
                  class="limit-text3"
                  v-if="yearLimit && !yearTimeLimit && software.purchaseCycle && software.noneApply"
                >
                  <div class="limit-line">{{ languages.afterInfo }}</div>
                  <div class="limit-line">
                    {{ languages.purchaseIn }}
                    {{ software.purchaseCycle }}
                    {{ languages.workDay }}
                  </div>
                </div>
              </div>
              <div v-if="!yearLimit || yearTimeLimit">
                <div class="card-content">
                  {{ languages.period }}
                  <span>{{ languages.long }}</span>
                </div>

                <div class="card-content" :style="lan !== 'cn' ? 'fontSize:12px' : ''">
                  {{ software.cost ? languages.estimate : languages.depCost }}
                  <span>
                    {{ software.cost ? yearCost + languages.everyYear : languages.high }}
                  </span>
                </div>
                <div class="card-content">
                  {{ languages.useFor }}
                  <span>{{ languages.dailyUse }}</span>
                </div>
              </div>
              <div
                class="radio-container"
                v-bind:class="selectCard === 3 ? 'radio-select' : 'radio-unselect'"
              >
                <div class="radio-dot" v-if="selectCard === 3"></div>
              </div>
              <img src="~/assets/pics/licence/tag3.png" alt="" />
            </div>
            <div class="triangle-up" v-if="selectCard === 3"></div>
          </div>
        </div>
      </div>
      <div class="bottom-container" v-if="selectCard !== ''">
        <div class="info-container" style="min-height: 20px">
          <div class="content-container" v-if="statusCheck() && !isVpUser && !isCostUser">
            <div class="step-progress">
              <img src="~/assets/pics/licence/info.png" alt="" />
              {{ languages.process }}
            </div>
            <div class="step-details">
              <div class="step-title one-line">
                {{ languages.lineManager }}
              </div>
              <!-- <div class="step-name">{{ leaderAndCostCenter.leader }}</div> -->
            </div>
            <template v-if="!lightApprove">
              <i
                class="el-icon-arrow-right div-line"
                v-if="selectCard === 3 || (selectCard === 2 && !isUed())"
              ></i>
              <div class="step-details" v-if="selectCard === 3 || (selectCard === 2 && !isUed())">
                <div class="step-title one-line">
                  {{ languages.costManager }}
                </div>
                <!-- <div class="step-name">{{ leaderAndCostCenter.costAdmin }}</div> -->
              </div>
              <i class="el-icon-arrow-right div-line" v-if="selectCard === 3"></i>
              <div class="step-details" v-if="selectCard === 3">
                <div class="step-title one-line">
                  {{ languages.financialManager }}
                </div>
                <!-- <div class="step-name">{{ leaderAndCostCenter.financeAdmin }}</div> -->
              </div>
            </template>
          </div>
          <div class="content-container" v-if="statusCheck() && !isVpUser && isCostUser">
            <div class="step-progress" v-if="selectCard === 3">
              <img src="~/assets/pics/licence/info.png" alt="" />
              {{ languages.process }}
            </div>
            <div class="step-details" v-if="selectCard === 3 && !lightApprove">
              <div class="step-title one-line">
                {{ languages.financialManager }}
              </div>
              <!-- <div class="step-name">{{ leaderAndCostCenter.financeAdmin }}</div> -->
            </div>
          </div>

          <div class="suggest-container" v-if="!statusCheck()">
            <div class="suggest-icon">!</div>
            <div class="suggest-content">
              <!-- 限制多次申请灵活申请 -->
              <div
                v-if="
                  (dayTimeLimit && selectCard === 1) ||
                  (monthTimeLimit && selectCard === 2) ||
                  (yearTimeLimit && selectCard === 3)
                "
              >
                <span>{{ languages.timeLimit }} {{ languages.applyLong }}</span>
              </div>
              <!-- 资源耗尽，提交IQ -->
              <div
                class="no-resource-suggest-content"
                v-else-if="
                  (dayLimit && selectCard === 1) ||
                  (monthLimit && selectCard === 2) ||
                  (yearLimit && selectCard === 3)
                "
              >
                <div class="no-resource-suggest-text">{{ languages.feedbackIq }}</div>
                <div class="no-resource-suggest-link">
                  <el-button type="text" size="small" @click="openExternal(languages.iqUrl)">{{
                    languages.submitIq
                  }}</el-button>
                </div>
              </div>
            </div>
            <div class="suggest-content" v-if="suggestSoftList.length > 0">
              {{ languages.rcSoft }}
            </div>
            <div class="soft-container" v-if="suggestSoftList.length > 0">
              <div
                class="soft-content"
                v-for="(item, index) in suggestSoftList"
                @click="goInstall(item.name)"
                :key="index"
              >
                <img :src="item.icon" alt="" />
                <div class="soft-name">{{ item.name }}</div>
              </div>
            </div>
            <div style="height: 10px" v-if="suggestSoftList.length > 0"></div>
          </div>
        </div>
        <div class="cover-line" v-if="statusCheck() && suggestSoftList.length > 0"></div>
        <div class="bottom-suggest" v-if="statusCheck() && suggestSoftList.length > 0">
          <div class="suggest-content" v-if="suggestSoftList.length > 0">
            {{ languages.rcSoft }}
          </div>
          <div class="soft-container" v-if="suggestSoftList.length > 0">
            <div
              class="soft-content"
              v-for="(item, index) in suggestSoftList"
              @click="goInstall(item.name)"
              :key="index"
            >
              <img :src="item.icon" alt="" />
              <div class="soft-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="tips-container" v-if="selectCard === 3 && !yearLimit && !yearTimeLimit">
          <span style="color: #f34500">*</span>
          {{ languages.longReturn }}
          <img src="~/assets/pics/licence/hand.png" alt="" />
          <span @click="openMyAuthDialog">{{ languages.click }}</span
          >{{ languages.return }}
        </div>
        <div class="tips-container" v-if="!showLong && (selectCard === 1 || selectCard === 2)">
          <span style="color: #f34500">*</span>
          {{ languages.otherP }}
          <img src="~/assets/pics/licence/hand.png" alt="" />
          <span @click="openAIChat">{{ languages.helpdesk }}</span
          >{{ languages.apply }}
        </div>
        <div class="confirm-container" v-if="statusCheck()">
          <div class="confirm-text" v-bind:style="statusCheck() ? '' : 'color:#ccc'">
            {{ languages.read }}
          </div>
          <el-button
            type="primary"
            v-bind:class="statusCheck() ? '' : 'disable-button'"
            @click="showApplyInfo"
          >
            {{ languages.goConfirm }}</el-button
          >
        </div>

        <!-- <div v-if="!statusCheck() && selectCard === 3"
             class="log-button"
             @click="handleLog">{{ languages.note }}</div> -->
      </div>
    </div>
    <el-dialog
      :visible.sync="showLicenseInfoDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      width="350px"
      top="30vh"
    >
      <div class="confirm-container">
        <div class="info-title">{{ languages.applyNote }}</div>
        <div class="info-tip">{{ isRelate ? languages.winMac : languages.winOnly }}</div>
        <div
          class="info-input"
          :hidden="
            isVpUser ||
            (isCostUser && selectCard !== 3) ||
            (isCostUser && selectCard === 3 && lightApprove)
          "
        >
          <el-input
            type="textarea"
            suffix-icon="el-icon-edit"
            maxlength="100"
            :rows="3"
            resize="none"
            show-word-limit
            :placeholder="languages.applyReason"
            v-model="reason"
          >
          </el-input>
        </div>
        <div
          class="info-content"
          :hidden="
            isVpUser ||
            (isCostUser && selectCard !== 3) ||
            (isCostUser && selectCard === 3 && lightApprove) ||
            (yearLimit && selectCard === 3)
          "
        >
          {{ languages.notes1 }}
          <span>{{ selectCard === 1 ? languages.days : languages.days.replace('3', '7') }}</span>
          {{ languages.notes2 }}
        </div>
        <div
          class="info-content"
          v-if="
            isVpUser ||
            (isCostUser && selectCard !== 3) ||
            (isCostUser && selectCard === 3 && lightApprove)
          "
        >
          <div class="content-line">{{ languages.vpTip1 }}</div>
          <div class="content-line">{{ languages.vpTip2 }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="button-cancel" @click="showLicenseInfoDialog = false">
          {{ languages.back }}
        </el-button>
        <el-button class="button-confirm" type="primary" @click="handleApply">
          {{ languages.confirm }}
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import tools from 'common/tools';

export default {
  data() {
    return {
      showLicenseInfoDialog: false,
      dayTimeLimit: false,
      dayLimit: false,
      dayCost: '',
      dayReleaseTime: '',
      monthTimeLimit: false,
      monthLimit: false,
      monthCost: '',
      monthReleaseTime: '',
      monthSelectLimit: false,
      yearTimeLimit: false,
      yearLimit: false,
      yearCost: '',
      yearReleaseTime: '',
      activeCard: '',
      selectCard: '',
      daySelect: 1,
      monthSelect: 1,
      showQuickCard: false,
      showShortCard: false,
      showLongCard: false,
      suggestSoftList: [],
      applyTypes: ['quick', 'short', 'long'],
      cardCount: 0,
      reason: '',
      isRelate: false,
    };
  },
  props: {
    show: Boolean,
    languages: Object,
    lan: String,
    user: Object,
    software: Object,
    stock: Object,
    lightApprove: Boolean,
    showLong: Boolean,
  },
  computed: {
    ...mapState(['softTotalDetailDatas', 'leaderAndCostCenter', 'isVpUser', 'isCostUser']),
  },
  watch: {
    stock(val) {
      if (val) this.costCalc(this.software.cost);
    },
    show(val) {
      if (val) this.handleStock(this.stock);
    },
    // software (val) {
    //   const jfMatch = (val.jobFamily && val.jobFamily.includes(this.user.jobFamily));
    //   if (jfMatch !== undefined) {
    //     this.longUser = jfMatch;
    //     console.log('>>>', this.longUser, val);
    //   }
    // },
  },
  methods: {
    ...mapMutations(['setSoftSearch', 'handleSoftSearch', 'setErrorTips', 'setDebugInfos']),
    ...mapActions(['isRelateSoftware', 'saveLog']),
    async showApplyInfo() {
      this.isRelate = await this.isRelateSoftware(this.software.id);
      this.showLicenseInfoDialog = true;
      this.reason = '';
    },
    isUed() {
      return this.software.jobFamily.indexOf(this.user.jobFamily) > -1;
    },
    costCalc(cost) {
      if (!cost) return;
      const total = cost.match(/\d+/g).join('');
      const unit = this.lan === 'cn' ? '元' : 'Yuan';
      this.dayCost = Math.round((total / 365) * this.daySelect) + unit;
      this.monthCost = Math.round((total / 365) * (this.monthSelect + 2) * 10) + unit;
      this.yearCost = total + unit;
    },
    openMyAuthDialog() {
      this.$parent.hideLicenceDialog();
      this.$parent.homeTemplate.showMyLicenseDialog = true;
    },
    openAIChat() {
      if (this.isRunning) return;
      window.location = this.languages.service;
    },
    handleStock(stock) {
      this.cardCount = 0;
      this.showQuickCard = false;
      const { quick, short, long } = stock;
      this.showQuickCard = this.software.assign.indexOf('quick') > -1;
      this.showShortCard = this.software.assign.indexOf('short') > -1;
      this.showLongCard = this.software.assign.indexOf('long') > -1;
      if (quick && this.showQuickCard) {
        this.dayTimeLimit = quick.lock;
        this.dayLimit = quick.stock <= 0;
        this.dayReleaseTime = quick.releaseTime;
        this.showQuickCard = quick.quickConfig;
      }

      if (short && this.showShortCard) {
        this.monthTimeLimit = short.lock;
        this.monthLimit = short.stock <= 0;
        this.monthSelectLimit = short.limit;
        if (short.limit) this.monthSelect = 1;
        this.monthReleaseTime = short.releaseTime;
      }
      if (long && this.showLongCard) {
        this.yearTimeLimit = long.lock;
        this.yearLimit = long.stock <= 0;
        this.yearReleaseTime = long.releaseTime;
      }
      if (this.showQuickCard) this.cardCount += 1;
      if (this.showShortCard) this.cardCount += 1;
      if (this.showLongCard) this.cardCount += 1;
      if (this.cardCount === 1) {
        if (this.showQuickCard) {
          this.chooseCard(1);
        } else {
          this.chooseCard(this.showShortCard ? 2 : 3);
        }
      }

      // this.monthLimit = true; // for test, commit before git update
      // this.yearLimit = true; // for test, commit before git update
      // this.yearReleaseTime = '2022-11-22'; // for test, commit before git update
    },
    closeDialog() {
      this.selectCard = '';
      this.activeCard = '';
      this.daySelect = 1;
      this.monthSelect = 1;
      this.$parent.hideLicenceDialog();
    },
    getBkBorder(index) {
      if (this.selectCard !== index) return '';
      switch (index) {
        case 1:
          return '3px solid #01c48e';
        case 2:
          return '3px solid #fda001';
        default:
          return '3px solid #00a5ff';
      }
    },
    cardMouseOver(index) {
      this.activeCard = index;
    },
    cardMouseLeave() {
      this.activeCard = '';
    },
    checkHoverShadow(index) {
      return index === this.activeCard ? '0 0 10px 5px #ccc' : '';
    },
    chooseCard(index) {
      this.selectCard = index;
      this.suggestSoftList = [];
      const replaceList = this.software.replaceSoftware;
      if (!replaceList) return;
      const idList = replaceList.split(',').map((item) => Number(item));
      idList.forEach((el) => {
        const idx = this.softTotalDetailDatas.findIndex((soft) => soft.id === el);
        if (idx > -1) this.suggestSoftList.push(this.softTotalDetailDatas[idx]);
      });
    },
    goInstall(soft) {
      this.saveLog({
        title: 'LicenceApply',
        target: 'Go Recommend Software',
        description: 'User Click Recommend Software',
        softwareName: this.software.name,
        softwareId: this.software.id,
        reserve1: soft,
      });
      this.closeDialog();
      setTimeout(() => {
        this.setSoftSearch(soft);
        this.handleSoftSearch(soft);
      }, 100);
    },
    handleApply() {
      this.showLicenseInfoDialog = false;
      if (!this.statusCheck()) return;
      const selectIndex = this.selectCard - 1;
      let session = '';
      let duration = 1;
      switch (selectIndex) {
        case 0:
          duration = this.daySelect;
          session = 'quick';
          break;
        case 1:
          duration = (this.monthSelect + 2) * 10;
          session = 'short';
          break;
        default:
          duration = 3650;
          session = 'long';
          break;
      }
      console.log(session, duration);
      this.$parent.submitApply('Submit', session, duration, this.reason.trim());
      this.closeDialog();
    },
    handleLog() {
      this.saveLog({
        title: 'LicenceApply',
        target: 'NeedRegister',
        description: this.applyTypes[this.selectCard - 1],
        softwareName: this.software.name,
        softwareId: this.software.id,
      });
      this.$parent.submitApply('Log', '', '', '');
      this.closeDialog();
    },
    statusCheck() {
      switch (this.selectCard) {
        case 1:
          if (this.dayLimit || this.dayTimeLimit) return false;
          break;
        case 2:
          if (this.monthLimit || this.monthTimeLimit) return false;
          break;
        case 3:
          if (this.yearTimeLimit) return false;
          if (this.yearLimit && !this.software.noneApply) return false;
          break;
        default:
          break;
      }
      return true;
    },
    openExternal(url) {
      tools.openUrl(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-style {
  border: 1px solid #000;
}

.main-container {
  margin-top: -20px;
  padding-bottom: 20px;

  .top-container {
    height: 44px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: linear-gradient(90deg, rgb(0, 183, 255) 0%, rgb(0, 128, 255) 100%);

    .top-tip {
      color: #fff;
      font-size: 16px;
      line-height: 24px;
      padding: 10px 20px;
      width: 400px;

      span {
        margin-left: 10px;
      }
    }

    .dialog-close {
      border-radius: 12px;
      border: 1px solid #fff;
      text-align: center;
      position: absolute;
      right: 20px;
      top: 10px;
      color: #fff;
      height: 24px;
      width: 24px;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .middle-container {
    .blank-container {
      width: 122px;
    }

    .depart-container {
      line-height: 20px;
      font-size: 12px;
      padding: 10px 20px 0 20px;

      span {
        border: 1px solid #bfe0fc;
        border-radius: 3px;
        height: 20px;
        font-size: 14px;
        color: #0086f6;
        line-height: 20px;
        padding: 2px 5px;
        margin-left: 10px;
      }
    }

    .select-container {
      padding: 10px 0px 5px 0;
      display: flex;
      text-align: center;
      cursor: pointer;

      .card-container {
        position: relative;
        height: 200px;
        width: 212px;
        background-size: 212px;
        background-position-y: -1px;
        margin-left: 28px;
        box-shadow: 0px 0 3px 0px #ccc;
        border-radius: 10px;

        .card-limit {
          position: absolute;
          z-index: 1;
          right: -20px;
          top: -12px;
          height: 22px;
        }

        .triangle-up {
          width: 0;
          height: 0;
          border-left: 16px solid transparent;
          border-right: 16px solid transparent;
          border-bottom: 13px solid #fed01d;
          position: absolute;
          bottom: -17px;
          left: 88px;
        }

        .card-header {
          color: #fff;
          line-height: 36px;
          font-size: 16px;
        }

        .limit-container {
          padding: 2px 0;
          margin-top: 10px;
          background-size: 200px;
          background-repeat: no-repeat;
          background-position-x: 5px;
          height: 70px;

          .limit-text,
          .limit-text2 {
            line-height: 35px;
            color: #f34500;
            font-size: 13px;
          }

          .limit-text3 {
            margin-top: 2px;
            color: #f34500;
            font-size: 12px;

            .limit-line {
              line-height: 16px;
            }
          }
        }

        .card-body {
          position: relative;

          .card-title {
            display: inline-block;
            line-height: 37px;
          }

          .card-select {
            border-bottom: 1px solid #f0f2f5;
            margin: 0 10px;
            height: 35px;

            .day-select {
              width: 45px;
              margin: 8px;
              padding: 1px;
              outline: none;
              text-align-last: center;
            }
          }

          .card-content {
            line-height: 22px;

            span {
              color: #00b87a;
              margin-left: 5px;
            }
          }

          .radio-container {
            text-align: center;
            width: 22px;
            height: 22px;
            border-radius: 11px;
            position: absolute;
            left: 93px;
            top: 130px;

            .radio-dot {
              background: #1466de;
              width: 12px;
              height: 12px;
              border-radius: 10px;
              margin: 5px;
            }
          }

          img {
            width: 64px;
            position: absolute;
            right: 3px;
            top: 118px;
          }
        }
      }
    }
  }

  .bottom-container {
    text-align: center;
    font-size: 12px;

    .info-container {
      display: flex;
      background: #fed01d;
      margin: 5px 25px 0 25px;
      border-radius: 8px;

      .content-container {
        display: flex;
        margin: 5px auto;
        line-height: 20px;
        color: #755008;

        .step-progress {
          line-height: 40px;
          margin-right: 10px;

          img {
            height: 18px;
            margin-bottom: -5px;
          }
        }

        .step-details {
          margin: 0 5px;
          display: flex;
          flex-direction: column;

          .step-title {
            color: #666;
          }

          .step-name {
            font-weight: 700;
          }
        }

        .div-line {
          margin: 0 10px;
          line-height: 40px;
          font-size: 20px;
        }

        .step-icon {
          background: #755008;
          color: #fff;
          width: 16px;
          height: 16px;
          border-radius: 16px;
          line-height: 16px;
          margin-top: 13px;
        }
      }
    }

    .suggest-container {
      color: #755008;
      // height: 105px;
      padding-bottom: 10px;
      position: relative;
      padding-top: 10px;
      padding-left: 45px;

      .suggest-icon {
        width: 15px;
        height: 15px;
        line-height: 15px;
        border: 1px solid #755008;
        border-radius: 15px;
        position: absolute;
        left: 20px;
        top: 10px;
      }
    }

    .tips-container {
      display: flex;
      color: #666;
      font-size: 12px;
      line-height: 16px;
      text-align: left;
      margin: 5px 25px 0 25px;

      img {
        width: 16px;
        cursor: pointer;
        margin: 0 1px 0 5px;
      }

      span {
        color: #1466de;
        cursor: pointer;
        margin-right: 5px;
      }
    }

    .confirm-container {
      height: 60px;

      .confirm-text {
        line-height: 30px;
        color: #1466de;
      }

      .disable-button {
        cursor: not-allowed;
        background: #ccc !important;
        border: none;
      }
    }

    .cover-line {
      height: 8px;
      margin: -8px 25px 0 25px;
      background: #fed01d;
      z-index: 1;
    }

    .bottom-suggest {
      // border: 1px solid #000;
      background: #f2f7ff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      margin: 0 25px;
      padding: 10px 10px 20px 20px;
      z-index: 1;
    }

    .suggest-content {
      text-align: left;
      width: 490px;

      .no-resource-suggest-content {
        display: flex;
        align-items: center;
        height: 16px;

        .no-resource-suggest-text {
          display: flex;
        }

        .no-resource-suggest-link {
          margin-left: -26px;
          margin-top: 2px;
        }
      }
    }

    .soft-container {
      display: flex;
      margin-top: 5px;

      .soft-content {
        height: 55px;
        margin-right: 30px;
        cursor: pointer;

        img {
          width: 48px;
          height: 48px;
          border-radius: 10px;
        }

        .soft-name {
          line-height: 15px;
          max-width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.radio-select {
  border: 1px solid #1466de;
}

.radio-unselect {
  border: 1px solid #aaa;
}

.log-button {
  margin: 5px auto;
  background: #1466de;
  color: #fff;
  width: 150px;
  padding: 5px;
  font-size: 12px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  box-shadow: 1px 1px 1px #ccc;
}

.info-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}

.info-input {
  margin: 10px 20px;
}

.info-content {
  white-space: pre-wrap;
  margin: 10px 20px 0 20px;
  line-height: 22px;

  .content-line {
    text-align: center;
  }

  span {
    font-weight: 600;
    color: #1466de;
  }
}

.info-tip {
  white-space: pre-wrap;
  margin: 5px 0 5px 0;
  font-size: 12px;
  color: #ff6600;
  line-height: 10px;
  text-align: center;
}

::v-deep .el-dialog {
  border-radius: 8px;
}

.one-line {
  line-height: 40px;
}

.hidden {
  display: none;
}
</style>
